import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-my-doctor',
  templateUrl: './my-doctor.component.svg',
})
export class MyDoctorComponent extends MedrecordIcon {
  viewHeight = 24;
  viewWidth = 24;
}
